<template>
  <b-row>
    <b-col cols="12">
      <agencies-table :key="$route.fullPath" />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import AgenciesTable from './AgenciesTable.vue'

export default {
  components: {
    BRow,
    BCol,
    AgenciesTable,
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
